import { cloneDeep, merge, pick } from 'lodash'

import { Colors, joinURLPath } from '@sigma-frontend-libs/commons'

import { globalErrorHandler, request, services } from '@/utils'

import { commonProperties } from '@/components/services/providers/utils'

import render from './render'

export default {
  name: 'IsActiveButton',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false,
      isActive: this.value.isActive
    }
  },

  methods: {
    async update() {
      try {
        this.loading = true
        const params = merge(pick(cloneDeep(this.value), commonProperties), { isActive: !this.isActive })
        const data = await request.update(joinURLPath(services.providers, this.value.id), { body: params })
        if (data) {
          this.isActive = data.isActive
          this.addSnackbar({
            text: this.getTranslate(`${services.providers}.snackbars.updated`),
            type: Colors.info
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
